import SvgExternalLink from '@kijiji/icons/src/icons/ExternalLink'
import { useTheme } from 'styled-components'

import {
  MaintainProtectImage,
  MaintainProtectLink,
  MaintainProtectTileContainer,
} from '@/components/brp/styled'
import { BodyText } from '@/ui/atoms/body-text'
import { Flex } from '@/ui/atoms/flex'
import { Spacing } from '@/ui/atoms/spacing'

export type MaintainProtectTile = {
  /**
   * Display label for the body type
   */
  label: string
  /**
   * Image source
   */
  imageSrc: string
  /**
   * Navigation URL
   */
  url: string
  /**
   * Function triggered on tile click
   */
  onClick: (tileLabel: string) => void
  /**
   * Check if is external link, open link in new tab
   */
  isExternalLink?: boolean
}

export const MaintainProtectTile = ({
  label,
  imageSrc,
  url,
  onClick,
  isExternalLink,
}: MaintainProtectTile) => {
  const { spacing, colors } = useTheme()

  const handleClick = () => {
    onClick(label)
  }

  return (
    <MaintainProtectLink href={url} noStyle onClick={handleClick} openInNewTab={!!isExternalLink}>
      <MaintainProtectTileContainer>
        <MaintainProtectImage srcImage={{ src: imageSrc }} alt={label} skipNextImage />
        <Spacing mLeft={spacing.default} fullWidth>
          <Flex alignItems="center" justifyContent="space-between">
            <BodyText weight="semiBold">{label}</BodyText>
            {isExternalLink && <SvgExternalLink size="default" color={colors.grey.primary} />}
          </Flex>
        </Spacing>
      </MaintainProtectTileContainer>
    </MaintainProtectLink>
  )
}
